import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Tabs,
  Tab,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@material-ui/icons/Close';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import OfferLetterIcon from '@material-ui/icons/Description';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import axios from 'src/utils/axios';
import Alert from 'src/components/Alert';
import ValueProposition from 'src/components/ValueProposition/index';
import SendIcon from '@material-ui/icons/Send';

const ProductPage = ({ consumerId, setValuePropositionDialog }) => {
  const { t } = useTranslation('overview');
  const [products, setProducts] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedWarrantyStartDate, setSelectedWarrantyStartDate] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCountOfSale, setSelectedCountOfSale] = useState(null);
  const [uyari, setUyari] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const [noSuitableOffer, setNoSuitableOffer] = useState(false);
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchData = async (id) => {
      const [productsResponse, contractsResponse] = await Promise.all([
        axios.get(`/GetConsumerValuePropositions/${id}`),
        axios.get(`/GetConsumerContracts/${id}`)
      ]);
  
      const newProducts = productsResponse.data;
      const newContracts = contractsResponse.data;

      if (newProducts === "") {
        setProducts([]);
      } else {
        setProducts(newProducts);
      }

      if (newContracts === "") {
        setContracts([]);
      } else {
        setContracts(newContracts);
      }
  
      if (newProducts.length === 0 && newContracts.length === 0) {
        setNoSuitableOffer(true);
      }
      else{
        setLoading(true);
      }
      
    };
  
    fetchData(consumerId);
  }, [consumerId]);

  // const fetchProductsByConsumerId = async (id) => {
  //   axios
  //     .get(`/GetConsumerValuePropositions/${id}`)
  //     .then(response => {
  //       if (response.data.length > 0 && response.data !== "") {
  //         setProducts(response.data);
  //       }
  //     })
  // };

  // const fetchContractsByConsumerId = async (id) => {
  //   axios
  //     .get(`/GetConsumerContracts/${id}`)
  //     .then(response => {
  //       if (response.data.length > 0 && response.data !== "") {
  //         setContracts(response.data);
  //       }
  //       if(products.length === 0 && contracts.length === 0){
  //         setNoSuitableOffer(true);
  //       }
  //     })
  // };

  const uyariKapat = () => {
    setUyari(false);
  };

  const setPrepareOfferLetterToConsumer = async (product) => {
    const dataBody = {
      AssetId: product.AssetId || 0,
      CountOfSale: product.CountofSale
    };
    const dataConfigCancellation = {
      headers: { 'Content-Type': 'application/json' }
    };

    try {
      const response = await axios.post(`/PrepareOfferLetterToConsumer`, dataBody, dataConfigCancellation);
      setResponseMessage("Offer Letter sent to Consumer!");
      setUyari(true);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const SendContractToConsumer = async (ContractId) => {
    try {
      const response = await axios.post(`/SendContractToConsumer/${ContractId}`);
      setResponseMessage("The contract was resent to the customer!");
      setUyari(true);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleProductClick = (product) => {
    setSelectedAsset(product.AssetId);
    setSelectedWarrantyStartDate(product.WarrantyStartDate);
    setSelectedCountOfSale(product.CountofSale);
    setDialogOpen(true);
  };

  const handleOfferLetterClick = (product) => {
    setPrepareOfferLetterToConsumer(product);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedAsset(null);
    // setValuePropositionDialog(false);
  };

  const handleContractLinkClick = (link) => {
    window.open(link, '_blank');
  };

  const handleMenuClick = (event, product) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedProduct(product);
  };

  const handleMenuClickSendContract = (ContractId) => {
    SendContractToConsumer(ContractId);
  };

  const handleMenuItemClick = (option, link) => {
    setMenuAnchorEl(null);
    if (option === 'Purchase') {
      handleProductClick(selectedProduct);
    }
    else if(option === 'Offer Letter'){
      handleOfferLetterClick(selectedProduct);
    }
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedProduct(null);
  };

  const activeContracts = contracts.filter(contract => contract.Active === 1);
  const passiveContracts = contracts.filter(contract => contract.Active === 0);

  return (
    <div>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert 
          onClose={uyariKapat} 
          severity="success" 
          message={responseMessage}>
        </Alert>
      </Snackbar>
  
      <style jsx>{`
        .product-page-container {
          padding: 20px;
          background-color: #f0f0f0; /* Grey background */
          display: flex;
        }
  
        .tabs-container {
          min-width: 200px; /* Set a min width for the tabs */
          margin-right: 20px; /* Space between tabs and content */
        }
  
        .content-container {
          flex-grow: 1; /* Allow content to take up remaining space */
          background-color: white; /* Ensure white background for content */
          padding: 20px;
          border: 1px solid #ccc; /* Optional border for better visual separation */
          border-radius: 4px;
        }
  
        .table-container {
          width: 100%; /* Ensure table container takes full width */
        }
      `}</style>
  
      <div className="product-page-container">
        {noSuitableOffer ? (
          <Typography variant="h5" color="error">
            {t('lblNoSuitableOffers')}
          </Typography>
        ) : loading ? (
          <>
            <div className="tabs-container">
              <Tabs
                orientation="vertical"
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label={t('lblWarrantyAndMaintenanceOptions')} />
                <Tab label={t('lblActiveContracts')} />
                <Tab label={t('lblPassiveContracts')} />
              </Tabs>
            </div>
  
            <div className="content-container">
              {value === 0 && (
                <div className="warranty-section">
                  <Typography variant="h4" className="section-title">
                    {t('lblWarrantyAndMaintenanceOptions')}
                  </Typography>
                  <TableContainer component={Paper} className="table-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t('lblProductDescription')}</TableCell>
                          <TableCell>{t('lblProductionYear')}</TableCell>
                          <TableCell>{t('lblProdMonth')}</TableCell>
                          <TableCell>{t('lblSerialNr')}</TableCell>
                          <TableCell>{t('lblCountOfSale')}</TableCell>
                          <TableCell>{t('lblSalesType')}</TableCell>
                          <TableCell>{t('lblWarrantyStartDate')}</TableCell>
                          <TableCell>{t('lblWarrantyEndDate')}</TableCell>
                          <TableCell>{t('lblExtendedWarrantyStartDate')}</TableCell>
                          <TableCell>{t('lblExtendedWarrantyEndDate')}</TableCell>
                          <TableCell>{t('lblAction')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {products.map((product) => (
                          <TableRow key={product.SerialNr}>
                            <TableCell>{product.ProductDescription}</TableCell>
                            <TableCell>{product.ProductionYear}</TableCell>
                            <TableCell>{product.ProductionMonth}</TableCell>
                            <TableCell>{product.SerialNr}</TableCell>
                            <TableCell>{product.CountofSale}</TableCell>
                            <TableCell>{product.SalesType}</TableCell>
                            <TableCell>{product.WarrantyStartDate}</TableCell>
                            <TableCell>{product.WarrantyEndDate}</TableCell>
                            <TableCell>{product.ExtendedWarrantyStartDate}</TableCell>
                            <TableCell>{product.ExtendedWarrantyEndDate}</TableCell>
                            <TableCell>
                              <IconButton
                                onClick={(event) => handleMenuClick(event, product)}
                                color="primary"
                              >
                                <MoreVertIcon />
                              </IconButton>
                              <Menu
                                anchorEl={menuAnchorEl}
                                keepMounted
                                open={Boolean(menuAnchorEl)}
                                onClose={handleMenuClose}
                                disableBackdropTransition
                                BackdropProps={{
                                  style: {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                <MenuItem onClick={() => handleMenuItemClick('Purchase')}>
                                  <ListItemIcon>
                                    <ShoppingCartIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText primary={t('lblPurchase')} />
                                </MenuItem>
                                <MenuItem onClick={() => handleMenuItemClick('Offer Letter', product.Offerlink)}>
                                  <ListItemIcon>
                                    <OpenInNewIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText primary={t('lblOfferLetterSend')} />
                                </MenuItem>
                                <MenuItem onClick={() => handleContractLinkClick(product.Offerlink)}>
                                  <ListItemIcon>
                                    <SendIcon fontSize="small" />
                                  </ListItemIcon>
                                  <ListItemText primary={t('lblOfferLetterPreview')} />
                                </MenuItem>
                              </Menu>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
  
              {value === 1 && (
                <div className="contracts-section">
                  <Typography variant="h4" className="section-title">
                    {t('lblActiveContracts')}
                  </Typography>
                  <TableContainer component={Paper} className="table-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t('lblContractCode')}</TableCell>
                          <TableCell>{t('lblWorkCase')}</TableCell>
                          <TableCell>{t('lblContractType')}</TableCell>
                          <TableCell>{t('lblSeller')}</TableCell>
                          <TableCell>{t('lblProductCode')}</TableCell>
                          <TableCell>{t('lblSerialNr')}</TableCell>
                          <TableCell>{t('lblSellingDate')}</TableCell>
                          <TableCell>{t('lblStartDate')}</TableCell>
                          <TableCell>{t('lblEndDate')}</TableCell>
                          <TableCell>{t('lblContract')}</TableCell>
                          <TableCell>{t('lblResendContract')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {activeContracts.map((contract) => (
                          <TableRow key={contract.ContractId}>
                            <TableCell>{contract.ContractCode}</TableCell>
                            <TableCell>{contract.WorkCaseId}</TableCell>
                            <TableCell>{contract.ContractType}</TableCell>
                            <TableCell>{contract.Seller}</TableCell>
                            <TableCell>{contract.SKU}</TableCell>
                            <TableCell>{contract.SerialNr}</TableCell>
                            <TableCell>{new Date(contract.SellingDate).toLocaleDateString()}</TableCell>
                            <TableCell>{new Date(contract.ContractStartDate).toLocaleDateString()}</TableCell>
                            <TableCell>{new Date(contract.ContractEndDate).toLocaleDateString()}</TableCell>
                            <TableCell>
                              <IconButton
                                color="primary"
                                onClick={() => handleContractLinkClick(contract.ContractLink)}
                              >
                                <OpenInNewIcon />
                              </IconButton>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                color="primary"
                                onClick={() => handleMenuClickSendContract(contract.ContractId)}
                              >
                                <SendIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
  
              {value === 2 && (
                <div className="contracts-section">
                  <Typography variant="h4" className="section-title">
                    {t('lblPassiveContracts')}
                  </Typography>
                  <TableContainer component={Paper} className="table-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t('lblContractCode')}</TableCell>
                          <TableCell>{t('lblWorkCase')}</TableCell>
                          <TableCell>{t('lblContractType')}</TableCell>
                          <TableCell>{t('lblSeller')}</TableCell>
                          <TableCell>{t('lblProductCode')}</TableCell>
                          <TableCell>{t('lblSerialNr')}</TableCell>
                          <TableCell>{t('lblSellingDate')}</TableCell>
                          <TableCell>{t('lblStartDate')}</TableCell>
                          <TableCell>{t('lblEndDate')}</TableCell>
                          <TableCell>{t('lblContract')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {passiveContracts.map((contract) => (
                          <TableRow key={contract.ContractId}>
                            <TableCell>{contract.ContractCode}</TableCell>
                            <TableCell>{contract.WorkCaseId}</TableCell>
                            <TableCell>{contract.ContractType}</TableCell>
                            <TableCell>{contract.Seller}</TableCell>
                            <TableCell>{contract.SKU}</TableCell>
                            <TableCell>{contract.SerialNr}</TableCell>
                            <TableCell>{new Date(contract.SellingDate).toLocaleDateString()}</TableCell>
                            <TableCell>{new Date(contract.ContractStartDate).toLocaleDateString()}</TableCell>
                            <TableCell>{new Date(contract.ContractEndDate).toLocaleDateString()}</TableCell>
                            <TableCell>
                              <IconButton
                                color="primary"
                                onClick={() => handleContractLinkClick(contract.ContractLink)}
                              >
                                <OpenInNewIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </div>
          </>
        ) : null}
      </div>
  
      {selectedAsset && (
        <Dialog
          fullScreen
          open={dialogOpen}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <IconButton
                color="primary"
                onClick={handleCloseDialog}
                aria-label="close"
                style={{ position: 'absolute', right: 0 }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <ValueProposition
              AssetId={selectedAsset}
              handleCloseDialog={handleCloseDialog}
              consumerId={consumerId}
              WarrantyStartDate={selectedWarrantyStartDate}
            />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default ProductPage;
